import { render } from "./FormCard.vue?vue&type=template&id=207c8b61&scoped=true&ts=true"
import script from "./FormCard.vue?vue&type=script&lang=ts"
export * from "./FormCard.vue?vue&type=script&lang=ts"

import "./FormCard.vue?vue&type=style&index=0&id=207c8b61&scoped=true&lang=scss"

import exportComponent from "/builds/Chirbou/digithia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207c8b61"]])

export default __exports__